/* eslint-disable @typescript-eslint/no-explicit-any */
import type { Client, RequestContext } from "../client";
import type { CertificateConfigurationResource } from "../resources/certificateConfigurationResource";
import type { CertificateResource } from "../resources/index";
import { BasicRepository } from "./basicRepository";
export type GetCertificateUsagesBffResponse = {
    Projects: UsageRecord[];
    LibraryVariableSets: UsageRecord[];
    Tenants: UsageRecord[];
    DeploymentTargets: UsageRecord[];
};
interface UsageRecord {
    Id: string;
    SpaceId: string;
    Name: string;
}
export class CertificateConfigurationRepository extends BasicRepository<CertificateConfigurationResource, CertificateConfigurationResource> {
    constructor(client: Client, requestContext: RequestContext) {
        super("CertificateConfiguration", client, requestContext);
    }
    global() {
        return this.get("certificate-global");
    }
    export(certificate: CertificateResource, exportOptions: any) {
        return this.client.get(this.requestContext, certificate.Links["Export"], exportOptions);
    }
    archive(certificate: CertificateResource) {
        return this.client.post(this.requestContext, certificate.Links["Archive"]);
    }
    unarchive(certificate: CertificateResource) {
        return this.client.post(this.requestContext, certificate.Links["Unarchive"]);
    }
    usage(certificate: CertificateResource) {
        const template = "~/bff/spaces/{spaceId}/certificates/{certificateId}/usages";
        return this.client.get<GetCertificateUsagesBffResponse>(this.requestContext, template, { certificateId: certificate.Id });
    }
    replace(certificate: CertificateResource, newCertificateData: any, newPassword: any) {
        return this.client.post(this.requestContext, certificate.Links["Replace"], {
            certificateData: newCertificateData,
            password: newPassword,
        });
    }
}
